import { axiosInstance } from "../../axiosConfig";

const extractFiles = (object: Record<string, any>): File[] => {
  let files: File[] = [];
  for (let key of Object.keys(object || {})) {
    if (key === "rawFile" && object[key] instanceof File) {
      files.push(object[key]);
    } else if (object[key] instanceof Object) {
      files.push(...extractFiles(object[key]));
    }
  }
  return files;
};

// dataProvider.create() (src/dataProvider.ts) returns
// { ...response.data, id: response.data._id }, but the API already renames
// _id to id on the wire, so that overwrites the real id with undefined.
// Harmless for the legacy *Create pages, which don't need the id back -
// but every creator page here does, to link its sub-records together, so
// this redoes the same multipart POST without the clobber. Shared by all
// creators (services/mainPage/faq) so the workaround stays in one place.
export const createWithId = async (
  resource: string,
  data: unknown
): Promise<string> => {
  const files = extractFiles(data as Record<string, any>);
  const form = new FormData();
  form.append(
    "request",
    new Blob([JSON.stringify(data)], { type: "application/json" })
  );
  files.forEach((file) => form.append("files", file));

  const response = await axiosInstance.post(`/api/v1/${resource}`, form);
  return response.data.id;
};
